import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { commonStyles } from '../styles/commonStyles';

// The one nav row for every funnel screen: ghost Terug, filled pill Volgende,
// optional centre slot (product counter). Deliberate exceptions that do NOT use
// this component: product-selection (status text + single forward button, no
// back exists) and the summary screen (Terug only — the primary CTA lives in
// the premium card).

interface WorkflowNavButtonsProps {
  onBack: () => void;
  onNext: () => void;
  backLabel?: string;
  nextLabel?: string;
  backDisabled?: boolean;
  nextDisabled?: boolean;
  nextLoading?: boolean;
  center?: React.ReactNode;
  /** Extra class for screen-specific responsive rules (mobile ordering hooks). */
  className?: string;
}

export const WorkflowNavButtons: React.FC<WorkflowNavButtonsProps> = ({
  onBack,
  onNext,
  backLabel = 'common.backPlain',
  nextLabel = 'common.nextPlain',
  backDisabled = false,
  nextDisabled = false,
  nextLoading = false,
  center,
  className,
}) => {
  const { t } = useTranslation();
  const [backHover, setBackHover] = useState(false);
  const nextBusy = nextDisabled || nextLoading;

  return (
    <nav style={commonStyles.navigation} className={`workflow-nav-buttons${className ? ` ${className}` : ''}`}>
      <button
        type="button"
        onClick={onBack}
        disabled={backDisabled}
        onMouseEnter={() => setBackHover(true)}
        onMouseLeave={() => setBackHover(false)}
        style={{
          ...commonStyles.buttonSecondary,
          ...(backHover && !backDisabled ? commonStyles.buttonSecondaryHover : {}),
          ...(backDisabled ? commonStyles.buttonDisabled : {}),
        }}
      >
        <ArrowLeft size={18} aria-hidden="true" />
        {t(backLabel)}
      </button>

      {center}

      <button
        type="button"
        onClick={onNext}
        disabled={nextBusy}
        style={{ ...commonStyles.buttonPrimary, ...(nextBusy ? (nextLoading ? commonStyles.buttonBusyWait : commonStyles.buttonBusyNotAllowed) : {}) }}
      >
        {nextLoading && <span style={commonStyles.navSpinner} aria-hidden="true" />}
        {t(nextLabel)}
        {!nextLoading && <ArrowRight size={18} aria-hidden="true" />}
      </button>
    </nav>
  );
};

export default WorkflowNavButtons;
